// extracted by mini-css-extract-plugin
module.exports = {"UrlPreviewCopy":"UrlPreviewCopy_UrlPreviewCopy__2rXMR"};